import React from 'react';
import { Badge } from './Badge';

/**
 * ActivityFeed - Activity feed component
 * Displays recent activities/events
 */
export const ActivityFeed = ({ activities = [], className = '' }) => {
  if (activities.length === 0) {
    return (
      <div className={`bg-white rounded-xl border border-gray-200 p-6 ${className}`}>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Activity</h3>
        <div className="text-center py-8">
          <svg className="w-12 h-12 mx-auto text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm text-gray-500">No recent activity</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-6 ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Activity</h3>
      <div className="space-y-4">
        {activities.map((activity, idx) => (
          <div key={idx} className="flex gap-3 pb-4 border-b border-gray-100 last:border-0 last:pb-0">
            <div className="flex-shrink-0">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                activity.type === 'create' ? 'bg-blue-100' :
                activity.type === 'update' ? 'bg-purple-100' :
                activity.type === 'delete' ? 'bg-red-100' :
                'bg-gray-100'
              }`}>
                {activity.icon || (
                  <svg className={`w-5 h-5 ${
                    activity.type === 'create' ? 'text-blue-600' :
                    activity.type === 'update' ? 'text-purple-600' :
                    activity.type === 'delete' ? 'text-red-600' :
                    'text-gray-600'
                  }`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                )}
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-gray-900">
                <span className="font-semibold">{activity.user || 'System'}</span>
                {' '}
                {activity.message}
              </p>
              {activity.metadata && (
                <div className="mt-1 flex items-center gap-2">
                  {activity.metadata.type && (
                    <Badge variant="info" size="sm">{activity.metadata.type}</Badge>
                  )}
                  {activity.metadata.status && (
                    <Badge 
                      variant={activity.metadata.status === 'published' ? 'success' : 'default'} 
                      size="sm"
                    >
                      {activity.metadata.status}
                    </Badge>
                  )}
                </div>
              )}
              <p className="text-xs text-gray-500 mt-1">{activity.timestamp}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;
